import Lib from '../../../commons/lib';

export default class Service {
  static idopontUrl = window.location.origin + '/api/idopont/';

  static helyszinUrl = window.location.origin + '/api/helyszin/';

  static partnerUrl = window.location.origin + '/api/partner/';

  // IDOPONT START

  static listSzolgaltatas(aktiv, dolgozoid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'szolgaltatas/list',
      args: { requestType: 'szolgaltatas-list' },
      params: {
        aktiv,
        dolgozoid
      }
    }], fnDone);
  }

  static listSzolgaltatasByDolgozok(aktiv, dolgozokArray, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'szolgaltatas/listbydolgozok',
      args: { requestType: 'szolgaltatas-listbydolgozok-get' },
      params: {
        aktiv,
        dolgozokArray
      }
    }], fnDone);
  }

  static addSzolgaltatas(szolgaltatas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'szolgaltatas',
      args: { requestType: 'szolgaltatas-post' },
      data: szolgaltatas
    }], fnDone);
  }

  static editSzolgaltatas(szolgaltatas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'szolgaltatas',
      args: { requestType: 'szolgaltatas-put' },
      data: szolgaltatas
    }], fnDone);
  }

  static deleteSzolgaltatas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.idopontUrl + 'szolgaltatas',
      args: { requestType: 'szolgaltatas-delete' },
      params: {
        id: id
      }
    }], fnDone);
  }

  static listDolgozo(onlywithszolgaltatas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'dolgozo/list',
      args: { requestType: 'dolgozo-list' },
      params: {
        onlywithszolgaltatas
      }
    }], fnDone);
  }

  static listDolgozoByTerem(teremid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'dolgozo/listbyterem',
      args: { requestType: 'dolgozo-listbyterem' },
      params: {
        teremid
      }
    }], fnDone);
  }

  static listAllDolgozo(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'dolgozo/listall',
      args: { requestType: 'dolgozo-listall' },
    }], fnDone);
  }

  static getDolgozo(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'dolgozo',
      args: { requestType: 'dolgozo-get' },
      params: {
        id: id
      }
    }], fnDone);
  }

  static addDolgozo(dolgozo, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'dolgozo',
      args: { requestType: 'dolgozo-post' },
      data: dolgozo
    }], fnDone);
  }

  static editDolgozo(dolgozo, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'dolgozo',
      args: { requestType: 'dolgozo-put' },
      data: dolgozo
    }], fnDone);
  }

  static deleteDolgozo(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.idopontUrl + 'dolgozo',
      args: { requestType: 'dolgozo-delete' },
      params: {
        id
      }
    }], fnDone);
  }

  static checkForFoglalasSor(bean, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'dolgozo/checkfoglalassor',
      args: { requestType: 'dolgozo-checkfoglalassor-put' },
      data: bean
    }], fnDone);
  }

  static listIsmetlodesEnum(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'naptar/ismetlodesenum',
      args: { requestType: 'naptar-ismetlodesenum-get' },
    }], fnDone);
  }

  static listNaptarNezet(kezdet, teremid, foglalasnelkul, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'naptar/listnezet',
      args: { requestType: 'naptar-listnezet-get' },
      params: {
        kezdet, teremid, foglalasnelkul
      }
    }], fnDone);
  }

  static addNaptar(naptar, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'naptar',
      args: { requestType: 'naptar-post' },
      data: naptar
    }], fnDone);
  }

  static copyDay(obj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'naptar/masolas',
      args: { requestType: 'naptar-masolas-post' },
      data: obj,
    }], fnDone);
  }

  static getNaptar(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'naptar',
      args: { requestType: 'naptar-get' },
      params: {
        id
      }
    }], fnDone);
  }

  static editNaptar(naptar, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'naptar',
      args: { requestType: 'naptar-put' },
      data: naptar
    }], fnDone);
  }

  static deleteNaptar(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.idopontUrl + 'naptar',
      args: { requestType: 'naptar-delete' },
      params: {
        id
      }
    }], fnDone);
  }

  static listUsersKeycloak(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'user/listusers',
      args: { requestType: 'user-listusers' },
    }], fnDone);
  }

  static listUsers(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'user/list',
      args: { requestType: 'user-list' },
    }], fnDone);
  }

  static addUser(user, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'user',
      args: { requestType: 'user-post' },
      data: user
    }], fnDone);
  }

  static editUser(user, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'user',
      args: { requestType: 'user-put' },
      data: user
    }], fnDone);
  }

  static deleteUser(userid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.idopontUrl + 'user',
      args: { requestType: 'user-delete' },
      params: {
        userid
      }
    }], fnDone);
  }

  static getPartnerParameters(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'foglalas/getpartnerparameters',
      args: { requestType: 'foglalas-getpartnerparameters-get' }
    }], fnDone);
  }

  static getFoglalas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'foglalas',
      args: { requestType: 'foglalas-get' },
      params: {
        id
      }
    }], fnDone);
  }

  static addFoglalas(obj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'foglalas',
      args: { requestType: 'foglalas-post' },
      data: obj
    }], fnDone);
  }

  static editFoglalas(obj, email, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'foglalas',
      args: { requestType: 'foglalas-put' },
      data: obj,
      params: {
        resend_email: email
      }
    }], fnDone);
  }

  static deleteFoglalas(id, ok, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.idopontUrl + 'foglalas',
      args: { requestType: 'foglalas-delete' },
      params: {
        id,
        ok
      }
    }], fnDone);
  }

  static listFoglalas(kezdet, vege, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'foglalas/list',
      args: { requestType: 'foglalas-list-get' },
      params: {
        kezdet,
        vege
      }
    }], fnDone);
  }

  static confirmList(foglalasids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'foglalas/confirmlist',
      args: { requestType: 'foglalas-confirmlist-put' },
      params: {
        foglalasids
      }
    }], fnDone);
  }

  static deleteList(foglalasids, ok, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.idopontUrl + 'foglalas/deletelist',
      args: { requestType: 'foglalas-deletelist-delete' },
      params: {
        foglalasids,
        ok
      }
    }], fnDone);
  }

  static listSablon(szolgaltatasid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'sablon/list',
      args: { requestType: 'sablon-list-get' },
      params: {
        szolgaltatasid
      }
    }], fnDone);
  }

  static initVariables(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'sablon/init',
      args: { requestType: 'sablon-init' }
    }], fnDone);
  }

  static addSablon(submitObj, id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'sablon',
      args: { requestType: 'sablon-post' },
      data: submitObj,
      params: {
        id
      }
    }], fnDone);
  }

  static getSablon(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'sablon',
      args: { requestType: 'sablon-get' },
      params: {
        id
      }
    }], fnDone);
  }

  static editSablon(submitObj, id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.idopontUrl + 'sablon',
      args: { requestType: 'sablon-put' },
      data: submitObj,
      params: {
        id
      }
    }], fnDone);
  }

  static deleteSablon(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.idopontUrl + 'sablon',
      args: { requestType: 'sablon-delete' },
      params: {
        id: id
      }
    }], fnDone);
  }

  static statisztikaXlsx(data, kezdoDatum, zaroDatum, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'naptar/list/xlsx',
      acceptType: 'application/json, application/octet-stream',
      data: data,
      params: {
        kezdoDatum: kezdoDatum,
        zaroDatum: zaroDatum
      }
    }], fnDone);
  }

  static getBeallitas(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'beallitas',
      args: { requestType: 'beallitas-get' }
    }], fnDone);
  }

  static insertOrModifyBeallitas(beallitasObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'beallitas',
      args: { requestType: 'beallitas-post' },
      data: beallitasObj
    }], fnDone);
  }

  static listKategoriaByRole(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'naptar/listkategoriabyrole',
      args: { requestType: 'naptar-list' }
    }], fnDone);
  }

  static vanUtkozes(hetvege, napkezdetora, naphosszperc, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'beallitas/vanUtkozes',
      args: { requestType: 'beallitas-get' },
      params: {
        hetvege: hetvege,
        napkezdetora: napkezdetora,
        naphosszperc: naphosszperc
      }
    }], fnDone);
  }

  // IDOPONT END

  // HELYSZIN START

  static listTerem(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem/listwithrolecheck',
      args: { requestType: 'terem-listwithrolecheck-get' }
    }], fnDone);
  }

  static getTeremByIds(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.helyszinUrl + 'terem/byids',
      args: { requestType: 'terem-byids-put' },
      data: ids
    }], fnDone);
  }

  static getHelyszinByIds(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.helyszinUrl + 'helyszin/byids',
      args: { requestType: 'helyszin-byids-put' },
      data: ids
    }], fnDone);
  }

  // HELYSZIN END

  // PARTNER START

  static getPartnerList(nev, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.partnerUrl + 'search/getlist',
      args: { requestType: 'search-getlist-put' },
      params: {
        service: 'IDOPONT_FOGLALAS',
        nev
      }
    }], fnDone);
  }

  static getPartner(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'search/get',
      args: { requestType: 'search-get-get' },
      params: {
        service: 'IDOPONT_FOGLALAS',
        id
      }
    }], fnDone);
  }

  static addPartnerBase(partnerObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.partnerUrl + 'partner/base',
      args: { requestType: 'partner-base-post' },
      data: partnerObject
    }], fnDone);
  }

  static initPartnerCsop(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'partnercsoport/init',
      args: { requestType: 'partnercsoport-init-list-active' }
    }], fnDone);
  }

  static listTelefonEnum(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'partner/telefonenum',
      args: { requestType: 'partner-telefonenum-list' }
    }], fnDone);
  }

  // PARTNER END

}